import { render } from "./ViewMarks.vue?vue&type=template&id=17db7262&scoped=true"
import script from "./ViewMarks.vue?vue&type=script&lang=js"
export * from "./ViewMarks.vue?vue&type=script&lang=js"

import "./ViewMarks.vue?vue&type=style&index=0&id=17db7262&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17db7262"]])

export default __exports__